/* jshint esversion: 6 */
/* jshint esversion: 11 */
import { useEffect, useState, useCallback, useContext } from 'react';
import { MyContext } from '../Context/MyProvider';
import { showToast } from '../showTost';
import secureLocalStorage from "react-secure-storage";
const Razorpay = ({ Amount, Attribute }) => {

    const { setPaymentStatus, setTransactionId } = useContext(MyContext);

    const [userData, setUserData] = useState();

    const openPayModal = useCallback(() => {

        const options = {
            key: Attribute,
            amount: Math.round(Number(Amount) * 100),
            name: "Doctorrhynor",
            description: "Online Consultation & Healthcare Services",
            image: "https://doctorrhynor.com/logo512.png",
            handler: (response) => {
                const txId = response.razorpay_payment_id;
                sessionStorage.setItem("transactionId", txId);
                setTransactionId(txId);
                setPaymentStatus("PaymentDone");
            },
            modal: {
                ondismiss: () => {
                    setPaymentStatus("PaymentFaild");
                    showToast({ title: "Payment Closed !!", id: "info" });
                }
            },
            prefill: {
                name: (userData && userData?.name) || "",
                contact: (userData && (userData?.phone || userData?.mobile)) || "",
                email: (userData && userData?.email) || "",
            },
            notes: {
                platform: "Doctorrhynor",
            },
            theme: {
                color: "#2563EB",
                hide_topbar: false,
            },
        };

        const rzp1 = new window.Razorpay(options);
        rzp1.open();

    }, [Amount, Attribute, userData]);

    useEffect(() => {
        const localData = secureLocalStorage.getItem("Loginuser");
        if (!Amount || !localData) return;

        const parsedData = JSON.parse(localData);
        setUserData(parsedData);

    }, [Amount]);

    useEffect(() => {
        if (userData && Amount) {
            openPayModal();
        }
    }, [Amount, userData]);

    return null;
};

export default Razorpay;
